import { Hero } from "@/components/Hero";
import { PhotoOfTheWeek } from "@/components/PhotoOfTheWeek";
import { SectionCard } from "@/components/SectionCard";
import { OnlineStore } from "@/components/OnlineStore";
import { Gallery } from "@/components/Gallery";
import { MeetKiddee } from "@/components/MeetKiddee";
import { PetsWall } from "@/components/PetsWall";
import { TopRatedRow } from "@/components/TopRatedRow";
import { KiddeeBundles } from "@/components/KiddeeBundles";
import { DiscountBand } from "@/components/DiscountBand";
import { SECTIONS } from "@/config/sections";
import { HOME } from "@/constants/testIds";
import { useSeo, DEFAULT_TITLE } from "@/lib/seo";
import { SiteJsonLd } from "@/components/SiteJsonLd";

export default function HomePage() {
  useSeo({ title: DEFAULT_TITLE, path: "/", image: "/media/kiddee/1.jpg",
    description: "Kiddee-approved dog and cat treats, tough toys, harnesses and beds, tested by our toy-obsessed rat terrier. Bundles save 10%. Free US shipping over $50." });
  return (
    <main>
      <SiteJsonLd />
      <Hero />
      <PhotoOfTheWeek />
      <section id="sections" className="max-w-7xl mx-auto px-6 lg:px-10 scroll-mt-24">
        <h2 className="font-heading text-base md:text-lg font-semibold uppercase tracking-[0.2em] text-[#4E7B68]">
          Where would you like to go?
        </h2>
        <div data-testid={HOME.sectionsGrid} className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {SECTIONS.map((s, i) => (
            <SectionCard key={s.id} section={s} index={i} />
          ))}
        </div>
      </section>
      <Gallery />
      <DiscountBand />
      <MeetKiddee />
      <PetsWall />
      <TopRatedRow />
      <KiddeeBundles />
      <OnlineStore />
    </main>
  );
}
